/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ShopifyInstallationDtoBase
 * auto generated base class for the model ShopifyInstallationDtoModel.
 */
export const ShopifyInstallationDtoModelBase = ModelBase
  .named('ShopifyInstallationDto')
  .props({
    __typename: types.optional(types.literal("ShopifyInstallationDto"), "ShopifyInstallationDto"),
    uuid: types.identifier,
    organizationUuid: types.union(types.undefined, types.string),
    shopDomain: types.union(types.undefined, types.string),
    shopifyStoreId: types.union(types.undefined, types.null, types.string),
    active: types.union(types.undefined, types.boolean),
    enabledBy: types.union(types.undefined, types.string),
    createdAt: types.union(types.undefined, types.string),
    updatedAt: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyInstallationDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get organizationUuid() { return this.__attr(`organizationUuid`) }
  get shopDomain() { return this.__attr(`shopDomain`) }
  get shopifyStoreId() { return this.__attr(`shopifyStoreId`) }
  get active() { return this.__attr(`active`) }
  get enabledBy() { return this.__attr(`enabledBy`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get updatedAt() { return this.__attr(`updatedAt`) }
}
export function selectFromShopifyInstallationDto() {
  return new ShopifyInstallationDtoModelSelector()
}

export const shopifyInstallationDtoModelPrimitives = selectFromShopifyInstallationDto().uuid.organizationUuid.shopDomain.shopifyStoreId.active.enabledBy.createdAt.updatedAt
